<template>
<div id="apptable" v-cloak>

    <b-card :header="header" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">           

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-9 text-right">
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-secondary" @click.stop="exportCSV()">
                        Esporta CSV
                    </b-button>
                    <b-button v-if="getShowInserisci()" style="margin:1px 0px 1px 2px;" size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="descrizione" scope="row">{{row.value}}</template>
                        <template slot="schedaVis" scope="row">{{row.value}}</template>
                        <template slot="tiposchedaVis" scope="row">{{row.value}}</template>
                        <template slot="socioVis" scope="row">{{row.value}}</template>                        
                        <template slot="importoacconto" scope="row">{{row.value}}</template>                       
                        <template slot="importosaldo" scope="row">{{row.value}}</template>  
                        <template slot="datainizio" scope="row">{{row.value | formatDate}}</template>  
                        <template slot="datafine" scope="row">{{row.value | formatDate}}</template> 
                        <template slot="note" scope="row">{{row.value | formatNote}}</template>
   
                        <template slot="modifica" scope="row">
                            <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                            <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                            <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                        </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione dello sconto #{{deleteModal.id}}: {{deleteModal.titolo}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>
    
</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'

import {
    Socio,
    Categoria
} from '../classes.js'

export default {
    name: 'apptable',
    data: function () {
        return {  
            deleteModal: {
                id: null,
                titolo: '',
                show: false
            },    
            id_scheda: this.$route.params.id_scheda || null, 
            tipo: this.$route.params.tipo || null,    
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                descrizione: {
                    label: 'Descrizione',
                    sortable: true
                },
                schedaVis: {
                    label: 'Scheda',
                    sortable: true
                },
                tiposchedaVis: {
                    label: 'Tipo scheda',
                    sortable: true
                },
                socioVis: {
                    label: 'Profilo soci',
                    sortable: true
                },
                importoacconto: {
                    label: 'Importo acconto €',
                    sortable: true
                },
                importosaldo: {
                    label: 'Importo saldo €',
                    sortable: true
                },
                datainizio: {
                    label: 'Data inizio',
                    sortable: true
                },
                datafine: {
                    label: 'Data fine',
                    sortable: true
                },
                note: {
                    label: 'Note',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        },
        header: {
            // getter
            get: function () {
                var aux = "Sconti";

                if(this.id_scheda != null && this.tipo == 'E'){
                    aux += " - Evento #" + this.id_scheda;
                }
                else if(this.id_scheda != null && this.tipo == 'I'){
                    aux += " - Impianto #" + this.id_scheda;
                }

                return aux;
            },
            // setter
            set: function (newValue) {

            }
        }
    },
    methods: {
        getShowInserisci(){

            return this.id_scheda != null;

        },        
        getDescTipo(tipo) {
            var cat = new Categoria();
            return cat.getTipoByFlag(tipo);
        },
        exportCSV() {

            if (this.items.length > 0) {
                var str = '"#";"Descrizione";"Scheda";"Tipo scheda";"Profilo soci";"Importo acconto €";"Importo saldo €";"Data inizio";"Data fine";"Note"\r\n';
                for (var i = 0; i < this.items.length; i++) {
                    str += '"' + this.items[i].id + '"' + ";";
                    str += '"' + this.items[i].descrizione.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].schedaVis.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].tiposchedaVis.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].socioVis.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].importoacconto + '"' + ";";
                    str += '"' + this.items[i].importosaldo + '"' + ";";
                    str += '"' + this.$options.filters.formatDate(this.items[i].datainizio) + '"' + ";";
                    str += '"' + this.$options.filters.formatDate(this.items[i].datafine) + '"' + ";";
                    str += '"' + this.items[i].note.replace(/\"/g, "\"\"") + '"' + "\r\n"; 
                }

                var a = document.createElement('a');
                var blob = new Blob([str], {
                    'type': 'application\/octet-stream'
                });

                a.href = window.URL.createObjectURL(blob);
                a.download = 'sconti_' + moment(String(new Date())).format('YYYYMMDD_HHmmss') + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function() {
                    document.body.removeChild(a);
                }, 100);

            }

        },
        insert() {   

            this.$router.push('/app/dettagliosconto/id_scheda/' + this.id_scheda + "/tipo/" + this.tipo);
                          
        },
        details(item, index, button) {

            this.$router.push('/app/dettagliosconto/' + item.id);

        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.titolo = item.descrizione;
            this.deleteModal.show = true;
        },
        delItem() {

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/sconti/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {
                        if (!response.data.error) {
                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            //forse può essere fatta diversamente e meglio
                            for (var i = 0; i < this.items.length; i++) {
                                if (this.items[i].id == this.deleteModal.id) {
                                    this.items.splice(i, 1); //delete
                                    break;
                                }
                            }
                            this.deleteModal.show = false;

                        } else {
                            throw new Error(response.data.message);
                        }
                    } catch (e) {
                        this.deleteModal.show = false;
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }
                })
                .catch(e => {
                    this.deleteModal.show = false;
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
    },
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY');
        },
        formatDateTime: function (value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
        },
        formatNote: function(value) {
            var numChar = 150;
            if (!value) return '';
            return value.substr(0, numChar) + (value.length <= numChar ? '' : ' ...');
        }
    },
    created: function () {

        

        if(!ctrlVismenu("O")){
            this.$router.replace('/accessdenied');
            return;
        }


        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/sconti/id_scheda/' + this.id_scheda + '/tipo/' + this.tipo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        var socio = new Socio();
                        apptable.items.forEach(function(element, index) {

                            element.datainizio_ric = apptable.$options.filters.formatDate(element.datainizio);
                            element.datafine_ric = apptable.$options.filters.formatDate(element.datafine);
                            element.socioVis = socio.getProfiloScontoByFlag(element.flgsocio);
                            element.schedaVis = element.titoloscheda;  
                            element.tiposchedaVis = apptable.getDescTipo(element.tipo); 
                            
                            

                        });                        

                        apptable.items = apptable.items.filter(function (element) {   
                            return ctrlViscategoria(element.id_categoriascheda);
                        });    

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
